@if (isMatMenu) {
  <button mat-menu-item
          [disabled]="disabled || tagsButtonDisabled()"
          [ngClass]="cssClass"
          [matTooltip]="title"
          [matTooltipDisabled]="!iconOnly"
          type="button"
          (click)="openSelectTagsModal()"
          data-test="dms-select-tags-button-button">
    <i [hidden]="labelOnly" class="icon fas fa-fw" [ngClass]="icon"></i>
    <span [hidden]="iconOnly" class="icon-label">{{ title }}</span>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [disabled]="disabled || tagsButtonDisabled()"
             [label]="!iconOnly ? title : ''"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="openSelectTagsModal()"
             data-test="dms-select-tags-button-button-2">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fas fa-fw" [ngClass]="icon"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fas fa-fw" [ngClass]="icon"></i>
      </ng-template>
    }
  </sk-button>
}
